import { Block } from '@components/Layout/Blocks';
import Typography from '@material-ui/core/Typography/Typography';
import React from 'react';

interface IQHeadlineProps {
    title: string;
    text?: any;
    headTitle?: any;
}

export default function IQHeadline(props: IQHeadlineProps) {
    return (
        <Block padding={'30px 24px'}>
            {props.headTitle ? (
                <Typography variant={'h1'} title={props.headTitle}>
                    {props.headTitle}
                </Typography>
            ) : null}
            <Typography variant={'h6'} title={props.title}>
                {props.title}
            </Typography>
            <Typography variant={'body1'} color={'textSecondary'} title={props.text}>
                {props.text}
            </Typography>
        </Block>
    );
}
